import { combineReducers } from 'redux'
import { reducer as auth } from './auth'
import { reducer as connectivity } from './connectivity'

export default combineReducers({ auth, connectivity })
